import React from 'react'

import type { TSupportedHostKey } from '@loc/hosts/src/constants'
import type { IGetHrefPropsOptions } from '../_hooks'


import { useHostKey } from '@/hooks/routes';
import { useMemo } from 'react';
export interface ILinkContextProps {
  prefixOrigin?: Exclude<IGetHrefPropsOptions['prefixOrigin'], false>
}

export const LinkContext = React.createContext<ILinkContextProps>({
  prefixOrigin: undefined,
})

export interface ILinkContextProviderProps extends ILinkContextProps {
  /**
   * 以对象方式配置 origin，方便统一管理
   */
  prefixOrigins?: Record<TSupportedHostKey, string>
  children?: React.ReactNode
}

export const LinkContextProvider = (props: ILinkContextProviderProps) => {
  const { prefixOrigin: customPrefixOrigin, prefixOrigins, children } = props

  const hostKey = useHostKey()
  const prefixOrigin = customPrefixOrigin || prefixOrigins?.[hostKey]

  const linkContextValue = useMemo(() => {
    return { prefixOrigin }
  }, [prefixOrigin])

  if (prefixOrigin) {
    return (
      <LinkContext.Provider value={linkContextValue}>
        {children}
      </LinkContext.Provider>
    )
  }

  return <>{children}</>
}
